import { useQueryClient } from '@tanstack/react-query';

import { useAxios } from '@/hooks/useAxios';
import type { CatalogProgram } from '@/sections/customerManagement/types';
import { useMutation, useQuery } from '@/utils/api';

export function useBountyCatalog() {
  const axios = useAxios({ doNotImpersonate: true });
  const queryClient = useQueryClient();

  const catalogQuery = useQuery({
    queryKey: ['bounty-catalog'],
    queryFn: async () => {
      const { data } = await axios.get<CatalogProgram[]>('/bounty-catalog');
      return data;
    },
    defaultErrorMessage: 'Failed to load bounty program catalog',
    staleTime: 5 * 60 * 1000,
  });

  const refreshMutation = useMutation({
    mutationFn: async () => {
      const { data } = await axios.post('/functions/bounty-catalog', {
        force: false,
      });
      return data;
    },
    defaultErrorMessage: 'Failed to refresh catalog',
  });

  const refreshCatalog = async () => {
    await refreshMutation.mutateAsync();
    queryClient.setQueryData(['bounty-catalog'], []);
    await new Promise(r => setTimeout(r, 3000));
    await queryClient.invalidateQueries({ queryKey: ['bounty-catalog'] });
  };

  return {
    catalog: catalogQuery.data ?? [],
    status: catalogQuery.status,
    isLoading: catalogQuery.isLoading,
    refreshCatalog,
  };
}
